import { getCurrentObserver, setCurrentObserver } from '../state/context';
import { createRoot, getOwner, runWithOwner } from '../state/scope';
/**
 * Compose runtime cleanup onto a node while preserving any existing owner
 * disposal chain. Intended for advanced integrations on `@smoothie-framework/ui/render`.
 */
export function withRuntimeCleanup(node, dispose, ownerName) {
    const runtimeNode = node;
    const previousDispose = runtimeNode._runtimeDispose;
    return {
        ...node,
        _runtimeDispose: previousDispose
            ? () => {
                previousDispose();
                dispose();
            }
            : dispose,
        _runtimeOwnerName: ownerName ?? runtimeNode._runtimeOwnerName,
    };
}
export function createRuntimeComponentRender(options) {
    return () => {
        const flushContext = getOwner()?.flushContext;
        return runWithOwner(null, () => createRoot((dispose) => withRuntimeCleanup(options.normalize(options.render()), dispose, options.ownerName), { flushContext }));
    };
}
function composeDisposes(previousDispose, nextDispose) {
    if (previousDispose && nextDispose) {
        return () => {
            nextDispose();
            previousDispose();
        };
    }
    return previousDispose ?? nextDispose;
}
export function createRuntimeComponentNode(options) {
    return {
        id: options.id,
        type: 'Fragment',
        props: {},
        children: [],
        key: options.key,
        _runtimeOwnerName: options.ownerName,
        _runtimeComponent: options.component,
        _runtimeRender: options.render,
    };
}
export function materializeRuntimeNode(node) {
    let current = node;
    while (current._runtimeRender) {
        const previousObserver = getCurrentObserver();
        setCurrentObserver(null);
        let rendered;
        try {
            rendered = current._runtimeRender();
        }
        finally {
            setCurrentObserver(previousObserver);
        }
        current = {
            ...rendered,
            id: current.id,
            key: current.key ?? rendered.key,
            _runtimeDispose: composeDisposes(current._runtimeDispose, rendered._runtimeDispose),
            _runtimeComponent: current._runtimeComponent ?? rendered._runtimeComponent,
            _runtimeOwnerName: current._runtimeOwnerName ?? rendered._runtimeOwnerName,
        };
    }
    return current;
}
//# sourceMappingURL=runtime-component.js.map